import { Avatar, Box, Button, Grid2, Stack, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { currency, stringAvatar, useApiRequest } from '../store/Common'
import { connect } from 'react-redux'
import { DateRangePicker } from 'rsuite';
import { ClipLoader } from 'react-spinners';
import { BarChart } from '@mui/x-charts';
import moment from 'moment';

function DashboardPage({name}) {

    const {postData} = useApiRequest();
    const {combine, allowedMaxDays, afterToday} = DateRangePicker;
    const screenWidth = window.innerWidth - 400;
    const [selectedDate, setSelectedDate] = useState([
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    ]);
    const [isLoading, setIsLoading] = useState(false);
    const [statData, setStatData] = useState(null);
    const [graphData, setGraphData] = useState(null);

    const [isCGraphLoading, setIsCGraphLoading] = useState(false);
    const [dateRange1, setDateRange1] = useState(null);
    const [dateRange2, setDateRange2] = useState(null);
    const [cGraphData, setCGraphData] = useState(null);


    const loadStat = useCallback(async(selectedDate) => {
        if(!selectedDate){
            return;
        }
        let start = 0;
        let end = 0;
        if(selectedDate && selectedDate.length === 2){
            start = selectedDate[0].setHours(0, 0, 0, 0)
            end = selectedDate[1].setHours(23, 59, 59, 999)
        }else{
            return;
        }
        setIsLoading(true);
        setStatData(null);
        const resp = await postData('stat/', {start, end});
        if(resp){
            setStatData(resp.data);
            setGraphData(resp.graph);
        }
        setIsLoading(false);
    },[postData]);

    useEffect(()=>{
        loadStat(selectedDate);
    },[selectedDate, loadStat]);

    const loadCompareGraphs = async() =>{
        if(!dateRange1 || !dateRange2){
            return;
        }
        let start = 0;
        let end = 0;
        if(dateRange1 && dateRange1.length === 2){
            start = dateRange1[0].setHours(0, 0, 0, 0)
            end = dateRange1[1].setHours(23, 59, 59, 999)
        }else{
            return;
        }
        let start2 = 0;
        let end2 = 0;
        if(dateRange2 && dateRange2.length === 2){
            start2 = dateRange2[0].setHours(0, 0, 0, 0)
            end2 = dateRange2[1].setHours(23, 59, 59, 999)
        }else{
            return;
        }
        const range1Interval = (dateRange1[1] - dateRange1[0]) / (1000 * 60 * 60 * 24);
        const range2Interval = (dateRange2[1] - dateRange2[0]) / (1000 * 60 * 60 * 24);
        if (range1Interval !== range2Interval) {
            alert('The intervals of the two date ranges must be equal.');
            return;
        }
        setIsCGraphLoading(true);
        setCGraphData(null);
        const resp = await postData('stat/comparegraph', {start, end, start2, end2});
        if(resp){
            setCGraphData(resp.data);
        }
        setIsCGraphLoading(false);
    }

    return (
       <Stack padding={2} sx={{background: '#d8d9dd', height: '100%', overflow: 'auto'}}>
            <Stack padding={2} pt={4} borderRadius={5} sx={{background: 'linear-gradient(to bottom, #e2e3e5, #cfd6e6)', flex: 1}}>
                <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'} gap={2}>
                    <Box width={450} mx={2}>
                        <DateRangePicker format="MMM dd, yyyy" character=" - " placeholder="Select Date Range" value={selectedDate} onChange={setSelectedDate} />
                    </Box>

                    <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'flex-end'} gap={2}>
                        <Box>
                            <Avatar {...stringAvatar(name)} />
                        </Box>
                        <Stack>
                            <Typography variant='h6' color='#444'>Welcome,</Typography>
                            <Typography variant='h5' color='#444'>{name}</Typography>
                        </Stack>
                    </Stack>
                </Stack>

                {isLoading && <Stack direction='row' gap={1} sx={{alignItems: 'center', justifyContent: 'center'}}>
                    <ClipLoader size={15} color='#000' />
                    <Typography variant='body'>Loading Data</Typography>
                </Stack>}


                {statData && <Box>
                    <Typography mt={4} variant='h5' mx={2}>Leads</Typography>
                    <Grid2 container>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Leads</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.totalLeads}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>New Leads</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.leadsNotInteracted}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Interacted Leads</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.leadsInteracted}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Hot Leads</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.hotLeads}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Cold Leads</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.coldLeads}</Typography>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </Box>}

                {statData && <Box>
                    <Typography mt={4} variant='h5' mx={2}>Customer</Typography>
                    <Grid2 container>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Customer</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.totalCustomers}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Customer with Annual Compliance</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.complianceCustomer}</Typography>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </Box>}

                {statData && <Box>
                    <Typography mt={4} variant='h5' mx={2}>Sales</Typography>
                    <Grid2 container>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Invoices</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.totalInvoices}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Sales</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{currency} {statData.invTotal}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Payments</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.totalPaymentCount}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Payment Received</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{currency} {statData.totalPaymentAmount}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Unpaid/Partial Paid Invoices</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.countDues}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Total Dues</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{currency} {statData.invDue}</Typography>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </Box>}

                {statData && <Box>
                    <Typography mt={4} variant='h5' mx={2}>Compliances & Jobs</Typography>
                    <Grid2 container>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Expired Not Done Compliances</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.expiredCompliance}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Not Done Compliances</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.complianceToBeDone}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Ongoing Compliances</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.complianceOngoing}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Expired Not Done Jobs</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.expiredJobs}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Not Done Jobs</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.jobToBeDone}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 size={3}>
                            <Stack m={1.5} sx={{borderRadius: 5, background: '#fff'}} p={2.5} gap={1}>
                                <Typography variant='h6' fontWeight={'bold'} color={'#d9166f'}>Ongoing Jobs</Typography>
                                <Typography variant='h4' fontWeight={'bold'}>{statData.jobOngoing}</Typography>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </Box>}

                <Stack mt={4} p={2} gap={3}>
                    <Typography variant='h5'>Compare Graphs</Typography>
                    <Stack flexDirection={'row'} gap={2} p={2} sx={{background: '#fff', borderRadius: 4, boxShadow: '5px 3px 5px #00000005'}}>
                        <Box width={300}>
                            <DateRangePicker format="MMM dd, yyyy" character=" - " placeholder="Select Date Range 1" shouldDisableDate={combine(allowedMaxDays(60), afterToday())} value={dateRange1} onChange={setDateRange1} />
                        </Box>
                        <Box width={300}>
                            <DateRangePicker format="MMM dd, yyyy" character=" - " placeholder="Select Date Range 2" shouldDisableDate={allowedMaxDays(60)} value={dateRange2} onChange={setDateRange2} />
                        </Box>
                        <Button variant="contained" onClick={loadCompareGraphs}>Load Graphs</Button>
                    </Stack>

                    {isCGraphLoading && <Stack direction='row' gap={1} sx={{alignItems: 'center', justifyContent: 'center'}}>
                        <ClipLoader size={15} color='#000' />
                        <Typography variant='body'>Loading Graph Data</Typography>
                    </Stack>}

                    {cGraphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                        <BarChart
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    data: cGraphData.leads.map((item, index) => `Day ${index + 1}`),
                                },
                            ]}
                            series={[
                                {
                                    data: cGraphData.leads.map((item, index) => item.value),
                                    color: "#007FFF",
                                    valueFormatter: (value, context) => cGraphData.leads[context.dataIndex]?moment(cGraphData.leads[context.dataIndex].date).format("Do MMM YYYY")+` - ${value}`:''
                                },
                                {
                                    data: cGraphData.leads2.map((item, index) => item.value),
                                    valueFormatter: (value, context) => cGraphData.leads2[context.dataIndex]?moment(cGraphData.leads2[context.dataIndex].date).format("Do MMM YYYY")+` - ${value}`:'',
                                    color: "#FF5733",
                                },
                            ]}
                            width={screenWidth}
                            height={600}/>
                        <Typography textAlign={'center'} variant='h6'>Daily New Leads</Typography>
                    </Box>}

                    {cGraphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                        <BarChart
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    data: cGraphData.leads.map((item, index) => `Day ${index + 1}`),
                                },
                            ]}
                            series={[
                                {
                                    data: cGraphData.notes.map((item, index) => item.value),
                                    color: "#007FFF",
                                    valueFormatter: (value, context) => cGraphData.notes[context.dataIndex]?moment(cGraphData.notes[context.dataIndex].date).format("Do MMM YYYY")+` - ${value}`:''
                                },
                                {
                                    data: cGraphData.notes2.map((item, index) => item.value),
                                    valueFormatter: (value, context) => cGraphData.notes2[context.dataIndex]?moment(cGraphData.notes2[context.dataIndex].date).format("Do MMM YYYY")+` - ${value}`:'',
                                    color: "#FF5733",
                                },
                            ]}
                            width={screenWidth}
                            height={600}/>
                        <Typography textAlign={'center'} variant='h6'>Daily Interacted Leads</Typography>
                    </Box>}

                    {cGraphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                        <BarChart
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    data: cGraphData.leads.map((item, index) => `Day ${index + 1}`),
                                },
                            ]}
                            series={[
                                {
                                    data: cGraphData.sales.map((item, index) => item.value),
                                    color: "#007FFF",
                                    valueFormatter: (value, context) => cGraphData.sales[context.dataIndex]?moment(cGraphData.sales[context.dataIndex].date).format("Do MMM YYYY")+` - ₹${value}`:''
                                },
                                {
                                    data: cGraphData.sales2.map((item, index) => item.value),
                                    valueFormatter: (value, context) => cGraphData.sales2[context.dataIndex]?moment(cGraphData.sales2[context.dataIndex].date).format("Do MMM YYYY")+` - ₹${value}`:'',
                                    color: "#FF5733",
                                },
                            ]}
                            width={screenWidth}
                            height={600}/>
                        <Typography textAlign={'center'} variant='h6'>Daily Sales</Typography>
                    </Box>}

                    {cGraphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                        <BarChart
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    data: cGraphData.leads.map((item, index) => `Day ${index + 1}`),
                                },
                            ]}
                            series={[
                                {
                                    data: cGraphData.salesCount.map((item, index) => item.value),
                                    color: "#007FFF",
                                    valueFormatter: (value, context) => cGraphData.salesCount[context.dataIndex]?moment(cGraphData.salesCount[context.dataIndex].date).format("Do MMM YYYY")+` - ₹${value}`:''
                                },
                                {
                                    data: cGraphData.salesCount2.map((item, index) => item.value),
                                    valueFormatter: (value, context) => cGraphData.salesCount2[context.dataIndex]?moment(cGraphData.salesCount2[context.dataIndex].date).format("Do MMM YYYY")+` - ${value}`:'',
                                    color: "#FF5733",
                                },
                            ]}
                            width={screenWidth}
                            height={600}/>
                        <Typography textAlign={'center'} variant='h6'>Daily Sales Count</Typography>
                    </Box>}

                </Stack>

                {graphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                    <BarChart
                        dataset={graphData.leads}
                        xAxis={[
                            {
                                scaleType: 'band',
                                categoryGapRatio: 0.3,
                                barGapRatio: 0.1,
                                data: graphData.leads.map((item) => moment(item.date).format("Do MMM")),
                                tickPlacement: 'middle',
                            },
                        ]}
                        series={[
                            { dataKey: 'value', label: 'Daily New Leads', color: '#fbb755' },
                        ]}
                        width={screenWidth}
                        height={600}
                        />
                    <Typography textAlign={'center'} variant='h6'>Daily New Leads</Typography>
                </Box>}

                {graphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                    <BarChart
                        dataset={graphData.notes}
                        xAxis={[
                            {
                                scaleType: 'band',
                                categoryGapRatio: 0.3,
                                barGapRatio: 0.1,
                                data: graphData.notes.map((item) => moment(item.date).format("Do MMM")),
                                tickPlacement: 'middle',
                            },
                        ]}
                        series={[
                            { dataKey: 'value', label: 'Daily Interacted Leads', color: '#fbb755' },
                        ]}
                        width={screenWidth}
                        height={600}
                        />
                    <Typography textAlign={'center'} variant='h6'>Daily Interacted Leads</Typography>
                </Box>}

                {graphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                    <BarChart
                        dataset={graphData.sales}
                        xAxis={[
                            {
                                scaleType: 'band',
                                categoryGapRatio: 0.3,
                                barGapRatio: 0.1,
                                data: graphData.sales.map((item) => moment(item.date).format("Do MMM")),
                                tickPlacement: 'middle',
                            },
                        ]}
                        series={[
                            { dataKey: 'value', label: 'Daily Sales (₹)', color: '#fbb755' },
                        ]}
                        width={screenWidth}
                        height={600}
                        />
                    <Typography textAlign={'center'} variant='h6'>Daily Sales</Typography>
                </Box>}

                {graphData && <Box mt={4} sx={{p: 2, background: '#fff', borderRadius: 5}}>
                    <BarChart
                        dataset={graphData.salesCount}
                        xAxis={[
                            {
                                scaleType: 'band',
                                categoryGapRatio: 0.3,
                                barGapRatio: 0.1,
                                data: graphData.salesCount.map((item) => moment(item.date).format("Do MMM")),
                                tickPlacement: 'middle',
                            },
                        ]}
                        series={[
                            { dataKey: 'value', label: 'Daily Sales Count', color: '#fbb755' },
                        ]}
                        width={screenWidth}
                        height={600}
                        />
                    <Typography textAlign={'center'} variant='h6'>Daily Sales Count</Typography>
                </Box>}

            </Stack>
        </Stack>
    )
}

const mapStatetoProps = (state) => {
    return {
        name: state.configs.name
    }
}
export default connect(mapStatetoProps)(DashboardPage)